module.exports = __webpack_public_path__ + "static/media/signal-graphic.fc6d72bd.svg";